import type { MePayload } from "@/lib/types";

export function canAuthorCoachFeedback(
  me: MePayload | null | undefined,
): boolean {
  return (
    !!me?.user?.is_global_admin ||
    !!me?.active_scope?.capabilities?.includes("coach_object:write")
  );
}

